import * as reducer from '../utils/reducers';
import featureReducer from './feature';

// chain slice reducer into feature reducer
const feedApp = reducer.reduce(
	featureReducer
);

export default feedApp;
